import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];
import { computed } from "../../adapter-vue";
import { isApp, isPC } from "../../utils/env";
export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    file: {
      "default": ""
    },
    size: {},
    width: {
      "default": "20px"
    },
    height: {
      "default": "20px"
    },
    hotAreaSize: {}
  },
  emits: ["onClick"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emits = __emit;
    var props = __props;
    var iconHotAreaSize = computed(function () {
      if (!props.hotAreaSize) {
        return undefined;
      }
      if (isNaN(Number(props.hotAreaSize))) {
        return String(props.hotAreaSize);
      }
      return "".concat(props.hotAreaSize, "px");
    });
    var iconWidth = computed(function () {
      return props.size ? props.size : props.width;
    });
    var iconHeight = computed(function () {
      return props.size ? props.size : props.height;
    });
    var handleImgClick = function handleImgClick(e) {
      emits("onClick", e);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        "class": _normalizeClass(['common-icon-container', !_unref(isPC) && 'common-icon-container-mobile']),
        style: _normalizeStyle({
          padding: _unref(iconHotAreaSize)
        }),
        onClick: handleImgClick
      }, [_unref(isApp) ? (_openBlock(), _createElementBlock("image", {
        key: 0,
        "class": "common-icon",
        src: props.file,
        style: _normalizeStyle({
          width: _unref(iconWidth),
          height: _unref(iconHeight)
        })
      }, null, 12, _hoisted_1)) : (_openBlock(), _createElementBlock("img", {
        key: 1,
        "class": "common-icon",
        src: props.file,
        style: _normalizeStyle({
          width: _unref(iconWidth),
          height: _unref(iconHeight)
        })
      }, null, 12, _hoisted_2))], 6);
    };
  }
});